import React from "react"
import {
  Box,
  Container,
  Grid,
  Heading,
  Image,
  Flex,
} from "@theme-ui/components"
import {
  Accordion as AccordionWrapper,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion"
import AccordionClosed from "../../images/coesi-accordion-closed.svg"
import AccordionOpened from "../../images/coesi-accordion-open.svg"
import { GatsbyImage } from "gatsby-plugin-image"
import VideoStream from "../VideoStream"
import { useColorMode } from "theme-ui"

const ImageAndText = ({ title, subtitle, body, media, accordion }) => {
  const [colorMode, setColorMode] = useColorMode()
  console.log(colorMode)
  return (
    <Box>
      <Box sx={{ mt: [2, 2, "60px", "60px"], mb: 2 }}>
        <Heading variant="h3" color="primary">
          {title}
        </Heading>
        <Box
          sx={{ color: "dark", fontSize: "21px" }}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      </Box>
      <Grid sx={{ mt: [1, 1, 4, 5] }} columns={[1, 1, "0.8fr 1.4fr"]} gap={[1]}>
        <Box sx={{ width: ["100%", "100%", "80%"] }}>
          {accordion && (
            <AccordionWrapper allowZeroExpanded>
              {accordion.map((item, index) => (
                <AccordionItem key={index}>
                  <AccordionItemState>
                    {state => (
                      <>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            <Flex
                              sx={{
                                width: "100%",
                                height: ["100%", "100px"],
                                mt: 4,
                                mb: 4,
                                borderRadius: "40px",
                                justifyContent: "space-between",
                                alignItems: "center",
                                cursor: "pointer",
                                backgroundColor: state.expanded
                                  ? "light"
                                  : "dark",
                                transition: "all 0.2s ease-in-out",
                                ".accordion-icon": {
                                  img: {
                                    filter:
                                      colorMode === "dark"
                                        ? "null"
                                        : "invert(100%)",
                                  },
                                },
                                "&:hover": {
                                  backgroundColor: state.expanded
                                    ? "dark"
                                    : "light",
                                  h3: {
                                    color: state.expanded ? "light" : "dark",
                                  },
                                  ".accordion-icon img": {
                                    // Imposta il filtro di inversione per l'SVG basandosi sullo stato di hover
                                    // Quando in light mode e l'elemento non è espanso (background chiaro all'hover), l'SVG diventa nero (invert(100%))
                                    // In tutti gli altri casi, l'SVG rimane bianco (invert(0) per dark mode o quando espanso in light mode)
                                    filter:
                                      colorMode === "light" ||
                                      colorMode === "dark"
                                        ? "invert(100%)"
                                        : "invert(0)",
                                  },
                                },
                              }}
                            >
                              <Heading
                                as="h3"
                                variant="h5"
                                sx={{
                                  flexBasis: "90%",
                                  fontSize: 2,
                                  p: 3,
                                  fontWeight: "bold",
                                  color: state.expanded ? "dark" : "light",
                                  mt: [0],
                                  mb: [0],
                                }}
                              >
                                {item.title}
                              </Heading>
                              <Box sx={{ mr: 4 }} className="accordion-icon">
                                {state.expanded ? (
                                  <Image src={AccordionOpened} />
                                ) : (
                                  <Image src={AccordionClosed} />
                                )}
                              </Box>
                            </Flex>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <Box
                            sx={{
                              color: "dark",
                              p: {
                                color: "dark",
                                fontSize: 0,
                              },
                            }}
                            dangerouslySetInnerHTML={{ __html: item.subtitle }}
                          />
                        </AccordionItemPanel>
                      </>
                    )}
                  </AccordionItemState>
                </AccordionItem>
              ))}
            </AccordionWrapper>
          )}
          {body && (
            <Box
              sx={{
                width: "100%",
                p: {
                  color: "dark",
                  fontSize: 3,

                  "&:last-of-type": {
                    mt: 6,
                  },
                },
                a: {
                  textAlign: "center",
                  letterSpacing: 1.1,

                  textDecoration: "none",
                  color: "white",
                  backgroundColor: "primary",
                  width: "fit-content",
                  maxWidth: "fit-content",
                  minWidth: "fit-content",
                  borderRadius: "40px",
                  border: "1px solid",
                  borderColor: "primary",
                  p: 2,
                  px: 3,
                  textTransform: "uppercase",
                  fontSize: "15px",
                  fontWeight: 400,
                },

                ul: {
                  fontFamily: "mono",
                  color: "dark",
                  textTransform: "uppercase",
                  fontWeight: 500,
                },
              }}
              dangerouslySetInnerHTML={{ __html: body }}
            />
          )}
        </Box>
        {media && (
          <Box>
            {media && media.mimeType === "image/jpeg" && (
              <Box
                sx={{
                  width: ["100%", "100%", "80%"],
                  height: "100%",
                  borderRadius: ["30px", "30px", "60px"],
                  maxHeight: "500px",
                  aspectRatio: "1/1",
                  overflow: "hidden",
                  ".gatsby-image-wrapper": {
                    height: "100%",
                  },
                }}
              >
                <GatsbyImage
                  image={media.gatsbyImageData}
                  alt={media.altText}
                  sx={{
                    height: "100%",
                  }}
                />
              </Box>
            )}
            {media &&
              (media.mimeType === "video/quicktime" ||
                media.mimeType === "video/mp4") && (
                <Box
                  sx={{
                    borderRadius: ["30px", "30px", "60px"],
                    overflow: "hidden",
                    height: "fit-content",
                  }}
                >
                  <VideoStream
                    muxPlaybackId={media.video.muxPlaybackId}
                    customData={media.customData}
                  />
                </Box>
              )}
          </Box>
        )}
      </Grid>
    </Box>
  )
}

export default ImageAndText
